module.exports = __webpack_public_path__ + "static/item-section-3-6d300422af93281450e3a24bea51f314.png";